import color from "../../constants/color";

const styles = {
  imageContainer: {
    position: "relative",
  },
  choose: {
    fontSize: "14px",
    color: color.card,
  },
  chooseIconSection: {
    backgroundColor: color.primary,
    display: "flex",
    p: 1,
    mx: 1,
    my: 2,
    borderRadius: "9px",
    width: "fit-content",
  },
  selectedImage: {
    width: "100%",
    height: "100%",
    border: "1px dashed #ccc",
    borderRadius:  "5px",
    position:"relative",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    cursor: "pointer",
    bgcolor: "transparent",
  },
  dragText: {
    fontSize: "12px",
    fontWeight: "500",
  },
  cameraIcon: {
    position: "absolute",
    bottom: 0,
    right: 1,
    padding: 0.5,
    borderRadius: "100%",
    backgroundColor: color.card,
  },
};
export default styles;
